import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { useTours } from "@/lib/siteData";
import { money, useAdminRows, isUuid, fmtDay, todaySP } from "@/lib/booking";
import { Card, Field, Select, SaveBtn, Ok, Err, SubTitle, useAction, smallBtn } from "./adminUI";

export default function SpecialPricesAdmin() {
    const tours = useTours(true).filter((t) => isUuid(t.id));
    const rows = useAdminRows("special-prices", (sb) => sb.from("tour_special_prices").select("*").gte("day", todaySP()).order("day"));
    const [f, setF] = useState({ tour_id: "", day: "", price: "", label: "" });
    const { run, busy, msg, err } = useAction();
    const set = (k) => (v) => setF((o) => ({ ...o, [k]: v }));
    const names = Object.fromEntries(tours.map((t) => [t.id, t.title]));

    return (
        <Card className="space-y-4">
            <SubTitle>Preço especial por data</SubTitle>
            <div className="grid gap-4 sm:grid-cols-4" data-testid="special-prices-admin">
                <Select label="Experiência" value={f.tour_id} onChange={set("tour_id")} options={[["", "Selecione"], ...tours.map((t) => [t.id, t.title])]} />
                <Field label="Data" type="date" value={f.day} onChange={set("day")} />
                <Field label="Preço (R$)" type="number" value={f.price} onChange={set("price")} />
                <Field label="Rótulo (ex.: feriado)" value={f.label} onChange={set("label")} />
            </div>
            <div className="flex items-center justify-end gap-3"><Ok msg={msg} /><Err msg={err} />
                <SaveBtn saving={busy} onClick={() => run(() => supabase.from("tour_special_prices").upsert({ ...f, price: Number(f.price) }, { onConflict: "tour_id,day" }))}>Salvar preço especial</SaveBtn></div>
            {(rows.data || []).map((r) => (
                <div key={r.id} className="flex items-center justify-between border-t border-ink/10 pt-3 text-sm">
                    <span>{names[r.tour_id]} · {fmtDay(r.day)} · <strong>{money(r.price)}</strong> {r.label}</span>
                    <button className={smallBtn} onClick={() => run(() => supabase.from("tour_special_prices").delete().eq("id", r.id))}>Remover</button>
                </div>
            ))}
        </Card>
    );
}
